import { Link } from "react-router-dom";
import moment from "moment";
import styles from "./ListRecord.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { ChevronDown, ChevronUp, Code, Trash2 } from "react-feather";
import dayjs from "dayjs";

const ListRecords = ({ filterredData, perPage, page, filterData, setDeleteModalOpen, setSelectecId }) => {
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  };

  return (<>
    <div className={`${styles.IncomeListUnderSec}`}>
      <div className={`${styles.ListCardDivSec}`}>
        {filterredData.length > 0 && filterredData.map((item, index) => {
          return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<Link to={"/expense/all-expense/edit/" + item?.id}>
            <div className={`${styles.CardDivList}`} key={index}>
              <div className={`${styles.FirstSec}`}>
                <p className={`${styles.Name}`}>{item?.payee_name} -{" "}<span>{item?.category?.title}</span></p>
                <p className={`${styles.Name}`}>{item?.property_name}{" "}{item?.apt_name ? `- ${item?.apt_name}` : ""}</p>
              </div>
              <div className={`${styles.SecondSec}`}>
                <p className={`${styles.Name}`}>Amount: <span>${item?.formatted_amount}</span></p>
                <p className={`${styles.Name}`}>Date: <span>{item?.due_date ? moment(item?.due_date).format("MM/DD/YYYY") : " - "}</span></p>
              </div>
              <div className={`${styles.ThirdSec}`}>
                {item?.status === 0 && (<span className={`${styles.StatusBadge} ${styles.Pending}`}>Upcoming</span>)}
                {item?.status === 1 && (<span className={`${styles.StatusBadge} ${styles.Failed}`}>Due</span>)}
                {item?.status === 2 && (<span className={`${styles.StatusBadge} ${styles.Confirm}`}>Paid</span>)}
                <p className={`${styles.Name} ${styles.IconBU}`}>
                  {item?.file_url ? (<a href={item.file_url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", alignItems: "center", color: "inherit", textDecoration: "none" }}>
                    <img src="/static/img/bill-icon.svg" style={{ cursor: "pointer" }} alt="" />
                  </a>) : ''}
                  <button onClick={(e) => { e.stopPropagation(); setSelectecId(item.id); setDeleteModalOpen(true); }} className={`${styles.DeleteExpenseBU}`}>
                    <Trash2 />
                  </button>
                </p>
              </div>
              <div className={`${styles.FullSec}`}>
                <p className={`${styles.Name}`}>{item?.description}</p>
              </div>
            </div>
          </Link>) : null;
        })}
      </div>

      <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={(e) => changeSortOrder("payee_name")}>
                PAYEE
                {sortItem === "payee_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "payee_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "payee_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("due_date")}>
                SUBMITTED
                {sortItem === "due_date" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "due_date" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "due_date" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 250 }} onClick={(e) => changeSortOrder("description")}>
                DESCRIPTION
                {sortItem === "description" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "description" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "description" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>
                CATEGORY
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("formatted_amount")}>
                AMOUNT
                {sortItem === "formatted_amount" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "formatted_amount" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "formatted_amount" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>

              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={(e) => changeSortOrder("property_name")}>
                PROPERTY
                {sortItem === "property_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "property_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "property_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("status")}>
                STATUS
                {sortItem === "status" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "status" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "status" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>

              <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>
                INVOICE
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterredData?.length > 0 && filterredData?.sort((a, b) => {
              if (sortItem === "description") {
                if (sortOrder === "desc") {
                  return a.description < b.description ? 1 : -1;
                } else {
                  return a.description > b.description ? 1 : -1;
                }
              } else if (sortItem === "formatted_amount") {
                if (sortOrder === "desc") {
                  return a.formatted_amount < b.formatted_amount ? 1 : -1;
                } else {
                  return a.formatted_amount > b.formatted_amount ? 1 : -1;
                }
              } else if (sortItem === "due_date") {
                if (sortOrder === "desc") {
                  return a.due_date < b.due_date ? 1 : -1;
                } else {
                  return a.due_date > b.due_date ? 1 : -1;
                }
              } else if (sortItem === "property_name") {
                if (sortOrder === "desc") {
                  return a.property_name < b.property_name ? 1 : -1;
                } else {
                  return a.property_name > b.property_name ? 1 : -1;
                }
              } else if (sortItem === "apt_name") {
                if (sortOrder === "desc") {
                  return a.apt_name < b.apt_name ? 1 : -1;
                } else {
                  return a.apt_name > b.apt_name ? 1 : -1;
                }
              } else if (sortItem === "status") {
                if (sortOrder === "desc") {
                  return a.status < b.status ? 1 : -1;
                } else {
                  return a.status > b.status ? 1 : -1;
                }
              } else {
                return a.id < b.id ? 1 : -1;
              }
            })?.map((item, index) => {
              return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<Link to={"/expense/all-expense/edit/" + item?.id} className={`${styles.TableLink}`}>
                <TableRow key={index}>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.payee_name}</TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.due_date ? moment(item?.due_date).format("MM/DD/YYYY") : " - "}</TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.description}</TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>
                    {/* <span className={`${styles.CategoryBadge}`} style={{ backgroundColor: item?.category?.color }}>{item?.category?.title}</span> */}
                    {item?.category?.title}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>${item?.formatted_amount}</TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.property_name}{" "}{item?.apt_name ? `- ${item?.apt_name}` : ""}</TableCell>
                  <TableCell>
                    {item?.status === 0 && (<span className={`${styles.StatusBadge} ${styles.Pending}`}>Upcoming</span>)}
                    {item?.status === 1 && (<span className={`${styles.StatusBadge} ${styles.Failed}`}>Due</span>)}
                    {item?.status === 2 && (<span className={`${styles.StatusBadge} ${styles.Confirm}`}>Paid: {dayjs(item?.payment_date).format('MM/DD/YYYY')}</span>)}
                  </TableCell>

                  <TableCell className={`${styles.TableBodyText} ${styles.IconBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    {item?.file_url ? (<a href={item.file_url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", alignItems: "center", color: "inherit", textDecoration: "none" }} className={`${styles.InvoiceLink}`}>
                      <img src="/static/img/bill-icon.svg" style={{ cursor: "pointer" }} alt="" />
                    </a>) : ''}
                    <button onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }} className={`${styles.DeleteExpenseBU}`}>
                      <Trash2 />
                    </button>
                  </TableCell>
                </TableRow>
              </Link>) : null;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  </>);
}

export default ListRecords;